import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AuthForm from './components/Auth/AuthForm';
import AuthCallback from './components/Auth/AuthCallback';
import PasswordResetRequest from './components/Auth/PasswordResetRequest';
import PasswordResetConfirm from './components/Auth/PasswordResetConfirm';
import HomePage from './pages/HomePage';
import GroupDetailsPage from './pages/GroupDetailsPage';
import JoinGroupsPage from './pages/JoinGroupsPage';
import FeedbackAdminPage from './pages/FeedbackAdminPage';

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4FFF7]">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#039855]"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  return children;
};



function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Auth routes */}
          <Route path="/auth/login" element={<AuthForm />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/forgot-password" element={<PasswordResetRequest />} />
          <Route path="/reset-password" element={<PasswordResetConfirm />} />

          {/* Protected routes */}
                          <Route path="/" element={
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                } />
          <Route path="/groups/:groupId" element={
            <ProtectedRoute>
              <GroupDetailsPage />
            </ProtectedRoute>
          } />
          <Route path="/join-groups" element={
            <ProtectedRoute>
              <JoinGroupsPage />
            </ProtectedRoute>
          } />
          <Route path="/feedback-admin" element={
            <ProtectedRoute>
              <FeedbackAdminPage />
            </ProtectedRoute>
          } />

          {/* Redirect all other routes to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
      <Analytics />
    </Router>
  );
}

export default App; 